import { z } from 'zod';
import { DecimalString, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/** CostAllocation — разложение себестоимости на layers. */
export const CostAllocation = z.object({
  id: UuidString,
  entity_id: UuidString,
  scope_type: z.enum(['work_order', 'period', 'item', 'batch']),
  scope_id: z.string(),
  material_cost: MoneyAmount,
  labor_cost: MoneyAmount,
  overhead_cost: MoneyAmount,
  total_cost: MoneyAmount,
  qty: DecimalString,
  per_unit_cost: MoneyAmount,
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type CostAllocation = z.infer<typeof CostAllocation>;
